import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { MaskedLine, Eyebrow } from "@/components/Reveal";

export default function DropBanner() {
  const [live, setLive] = useState(false);

  useEffect(() => {
    api.get("/drop-info").then((r) => setLive(Boolean(r.data.live))).catch(() => {});
  }, []);

  if (!live) return null;

  return (
    <section className="relative border-b border-gold/40 overflow-hidden" data-testid="drop-live-banner">
      <div className="absolute inset-0 bg-gradient-to-b from-gold/15 via-noir-bg/60 to-noir-bg" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 text-center">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
          <Eyebrow className="justify-center">The Wait Is Over</Eyebrow>
        </motion.div>
        <h2 className="font-display font-extrabold uppercase leading-[0.9] mt-6">
          <MaskedLine delay={0.15}><span className="block text-[13vw] sm:text-7xl lg:text-8xl text-gold">Drop 002</span></MaskedLine>
          <MaskedLine delay={0.3}><span className="block text-[13vw] sm:text-7xl lg:text-8xl text-cream">Is Live</span></MaskedLine>
        </h2>
        <motion.p
          className="mt-6 text-cream/60 text-sm sm:text-base max-w-md mx-auto"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          The Panther Legacy Long Sleeve leads the drop, with the Legacy Tee, Legacy Hoodie, and full Legacy Bundle behind it. Limited units — no second pressings.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.75, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <Link to="/shop?drop=new" className="inline-flex items-center gap-3 mt-8 bg-gold text-noir-bg px-10 py-4 font-mono2 text-[11px] tracking-[0.25em] uppercase hover:bg-cream transition-colors duration-300" data-testid="drop-live-shop-cta">
            Shop Drop 002 <ArrowRight size={14} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
